/**
 * Not used atm when starting to use make sure to add the proper typing to window.d.ts for the window variable
 * import "./site/google";
 */

import.meta.glob(["../images/**"]);

import { createPinia } from "pinia";

const pinia = createPinia();

import { createApp } from "vue/dist/vue.esm-bundler.js";
import { useLabelStore } from "./site/stores/label";

const app = createApp({
    mounted() {
        // flash_session();
    },
    created() {
        const labelStore = useLabelStore();
        labelStore.setFromJsonString(window.labels);
    },
});

app.use(pinia);

import { defineAsyncComponent } from "vue";
import AddToCart from "./site/Components/Cart/AddToCart.vue";
import Cart from "./site/Components/Cart/Cart.vue";
import CartHeader from "./site/Components/Cart/CartHeader.vue";
import CartOverview from "./site/Components/Cart/CartOverview.vue";
import Messages from "./site/Components/Messages.vue";
import Modal from "./site/Components/Modal.vue";
import AddToCartDetail from "./site/Components/Product/AddToCartDetail.vue";
import AfterAdding from "./site/Components/Product/AfterAdding.vue";
import Images from "./site/Components/Product/Images.vue";
import ProductTabs from "./site/Components/Product/ProductTabs.vue";
import SearchBar from "./site/Components/Search/SearchBar.vue";

import Flag from "./site/ui/Flag.vue";

app.component("cart-overview", CartOverview)
    .component("flag", Flag)
    .component("cart-header", CartHeader)
    .component("add-to-cart", AddToCart)
    .component("cart", Cart)
    .component(
        "address-input",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressEntityInput.vue"),
        ),
    )
    .component(
        "address-selector",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressSelector.vue"),
        ),
    )
    .component(
        "address-list",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressList.vue"),
        ),
    )
    .component(
        "address-item",
        defineAsyncComponent(
            () => import("./site/Components/Address/AddressItem.vue"),
        ),
    )
    .component("modal", Modal)
    .component(
        "product",
        defineAsyncComponent(
            () => import("./site/Components/Product/Product.vue"),
        ),
    )
    .component(
        "product-overview",
        defineAsyncComponent(
            () => import("./site/Components/Product/ProductOverview.vue"),
        ),
    )
    .component(
        "contact-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/ContactForm.vue"),
        ),
    )
    .component(
        "newsletter-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/NewsletterForm.vue"),
        ),
    )
    .component("search-bar", SearchBar)
    .component(
        "video-wrapper",
        defineAsyncComponent(
            () => import("./site/Components/VideoWrapper.vue"),
        ),
    )
    .component(
        "cart-status",
        defineAsyncComponent(
            () => import("./site/Components/Cart/CartStatus.vue"),
        ),
    )
    // Async / lazy load components
    .component(
        "skeleton",
        defineAsyncComponent(() => import("./site/Components/Skeleton.vue")),
    )
    .component(
        "prevent-interaction",
        defineAsyncComponent(
            () => import("./site/Components/PreventInteraction.vue"),
        ),
    )
    .component(
        "carousel",
        defineAsyncComponent(() => import("./site/Components/Carousel.vue")),
    )
    .component(
        "product-carousel",
        defineAsyncComponent(
            () => import("./site/Components/Product/ProductCarousel.vue"),
        ),
    )
    .component(
        "carousel-item",
        defineAsyncComponent(
            () => import("./site/ui/carousel/CarouselItem.vue"),
        ),
    )
    .component(
        "selected-icon",
        defineAsyncComponent(
            () => import("./site/Components/SelectedIcon.vue"),
        ),
    )
    .component("messages", Messages)
    .component("product-images", Images)
    .component("product-tabs", ProductTabs)
    .component("add-to-cart-detail", AddToCartDetail)
    .component("after-adding", AfterAdding)
    .component(
        "quickorder-overview",
        defineAsyncComponent(
            () => import("./site/Components/Quickorder/QuickorderOverview.vue"),
        ),
    )
    .component("after-adding", AfterAdding)
    .component(
        "purchase-list-overview",
        defineAsyncComponent(
            () =>
                import(
                    "./site/Components/PurchaseList/PurchaseListOverview.vue"
                ),
        ),
    );

app.mount("#app");
